export function lockBody() {
    const bodyStyles = document.body.style.cssText;
    document.body.classList.add('no-scroll');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return bodyStyles;
}

export function unlockBody(oldStyles: string) {
    document.body.style.cssText = oldStyles || '';
    document.body.classList.remove('no-scroll');
    document.body.style.overflow = 'visible';
    document.documentElement.style.overflow = '';
}